<template>
    <b-modal v-model="modalGalleryEdit" :width="468" scroll="keep">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Editar
          </h3>
          <hr />
          <div>
            <b-field
              label="Posición"
            >
              <b-input v-model="data.position" type="number" min="0"></b-input>
            </b-field>
            <b-field label="Tipo de opción">
              <b-select
                placeholder="Seleccione una opción"
                expanded
                class="selectForm"
                v-model="data.gallery_type"
              >
                <option value="IMAGE">
                  Imagen
                </option>
                <option value="VIDEO">
                  Video
                </option>
              </b-select>
            </b-field>
            <b-field
              label="Imagen"
              v-if="data.gallery_type === 'IMAGE'"
              :custom-class="$v.data.image.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.data.image.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.data.image.required && $v.data.image.$error
                }
              ]"
            >
              <upload
                :image="data.image"
                @change="uploadFileImage"
              ></upload>
            </b-field>
            <b-field
              label="Url Youtube"
              v-else
              :custom-class="$v.data.video.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.data.video.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.data.video.required && $v.data.video.$error
                }
              ]"
            >
              <b-input v-model="data.video"></b-input>
            </b-field>
          </div>
          <hr />
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="modalGalleryEdit = false"
                >Cerrar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="loading"
                @click.native="postInfo"
                >Guardar</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Upload from '@/components/base/Upload'
import Button from '@/components/form/Button'
import ProductService from '@/services/ProductService'
export default {
  components: {
    Upload,
    Button
  },
  props: {
    idGallery: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: {
        id: 0,
        gallery_type: 'IMAGE',
        image: '',
        video: '',
        position: 1,
        product: this.$route.params.id
      },
      formData: new FormData(),
      modalGalleryEdit: true,
      loading: false
    }
  },
  validations: {
    data: {
      position: { required },
      video: { required },
      image: { required }
    }
  },
  watch: {
    modalGalleryEdit() {
      this.$emit('hidden')
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        const response = await ProductService.getGalleryDetail(this.idGallery)
        this.data = response.data
        if (this.data.image === 'https://dev-api-pedidos.weeare.pe/media/images/defaults/product-no-imagnulle.jpg') {
          this.data.image = ''
        }
      } catch (error) {
        this.modalGalleryEdit = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    async postInfo() {
      if (this.data.gallery_type === 'IMAGE') {
        if (this.data.route_image === '') {
          this.$v.$touch()
          return
        }
      } else {
        if (this.data.video === '') {
          this.$v.$touch()
          return
        }
      }
      this.loading = true
      try {
        this.formData.append('gallery_type', this.data.gallery_type)
        this.formData.append('position', this.data.position)
        this.formData.append('video', this.data.video)
        this.formData.append('product', this.data.product)
        await ProductService.putGalleryDetail(this.idGallery, this.formData)
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se guardó correctamente.'
        })
        this.modalGalleryEdit = false
        this.$emit('reload')
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    uploadFileImage(file) {
      if (file) {
        this.formData.append('image', file)
        this.data.route_image = file
      }
    }
  }
}
</script>
